webpackJsonp([114276838955818,60335399758886],{

/***/ 98:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(230);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(98);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'bg-near-black white-60 pv4 pv5-ns' },
	    _react2.default.createElement(
	      _Container2.default,
	      { className: 'flex flex-column' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column mv2 mv0-ns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column flex-row-ns justify-between' },
	          _react2.default.createElement(
	            'p',
	            { className: 'f7 mv0 mv2-ns' },
	            '\xA9 ',
	            new Date().getFullYear(),
	            ' Ron Gierlach'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'tr-ns f7 mv3 mv2-ns' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/', className: 'link white-60 dim' },
	              'Home'
	            ),
	            '\xA0/\xA0',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/work', className: 'link white-60 dim' },
	              'Work'
	            ),
	            '\xA0/\xA0',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/blog', className: 'link white-60 dim' },
	              'Blog'
	            ),
	            '\xA0/\xA0',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/contact', className: 'link white-60 dim' },
	              'Contact'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'f7 mv0 mv2-ns' },
	          _react2.default.createElement(
	            'a',
	            { className: 'link white-80 dim', href: 'https://github.com/rongierlach/yfr-dot-com', target: '_blank' },
	            'Site'
	          ),
	          '\xA0built with\xA0',
	          _react2.default.createElement(
	            'a',
	            { className: 'link white-80 dim', href: 'https://www.gatsbyjs.org/', target: '_blank' },
	            'Gatsby'
	          ),
	          ',\xA0',
	          _react2.default.createElement(
	            'a',
	            { className: 'link white-80 dim', href: 'http://tachyons.io/', target: '_blank' },
	            'Tachyons'
	          ),
	          '\xA0and\xA0',
	          _react2.default.createElement(
	            'a',
	            { className: 'link white-80 dim', href: 'http://buttercms.com/', target: '_blank' },
	            'ButterCMS'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Hamburger = function Hamburger(_ref) {
	  var open = _ref.open,
	      props = _objectWithoutProperties(_ref, ['open']);
	
	  return _react2.default.createElement(
	    'button',
	    _extends({
	      className: '\n      mr3\n      outline-0\n      hamburger hamburger--squeeze\n      ' + (open ? 'is-active' : '') + '\n    ',
	      type: 'button'
	    }, props),
	    _react2.default.createElement(
	      'span',
	      { className: 'haumburger-box' },
	      _react2.default.createElement('span', { className: 'hamburger-inner' })
	    )
	  );
	};
	
	exports.default = Hamburger;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Nav = __webpack_require__(130);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _MobileNav = __webpack_require__(217);
	
	var _MobileNav2 = _interopRequireDefault(_MobileNav);
	
	var _Hamburger = __webpack_require__(215);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _zapV = __webpack_require__(526);
	
	var _zapV2 = _interopRequireDefault(_zapV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { open: false }, _this.closeNav = function () {
	      _this.setState({ open: false });
	    }, _this.toggleNav = function (e) {
	      e.preventDefault();
	      _this.setState({ open: !_this.state.open });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	    var open = this.state.open;
	
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'bg-near-black flex-column w-100 shadow-3-ns overflow-y-hidden' },
	      _react2.default.createElement(
	        _Container2.default,
	        { className: 'flex flex-row wrap justify-start items-center pv3 bg-inherit relative z-2' },
	        _react2.default.createElement('div', { className: 'flex-auto w-third dn-ns' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-auto w-third tc tl-ns' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', onClick: this.closeNav, className: 'link near-white hover-gold f3 ttu tracked b' },
	            _react2.default.createElement('img', { className: 'v-mid dib m-auto', style: { width: '2.5rem', height: '2.5rem' }, src: _zapV2.default })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-auto w-third dn-ns relative tr pr3' },
	          _react2.default.createElement(_Hamburger2.default, { open: open, onClick: this.toggleNav })
	        ),
	        _react2.default.createElement(_Nav2.default, { className: 'dn flex-ns flex-row' })
	      ),
	      open && _react2.default.createElement('div', {
	        onClick: this.closeNav,
	        className: 'db w-100 h-100 top-0 left-0 absolute'
	      }),
	      _react2.default.createElement(_MobileNav2.default, { open: open, onNavigate: this.closeNav })
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(197);
	
	var _Nav = __webpack_require__(130);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MobileNav = function MobileNav(_ref) {
	  var open = _ref.open,
	      props = _objectWithoutProperties(_ref, ['open']);
	
	  return _react2.default.createElement(
	    _reactMotion.Motion,
	    {
	      style: { offsetY: (0, _reactMotion.spring)(open ? 0 : -100) }
	    },
	    function (_ref2) {
	      var offsetY = _ref2.offsetY;
	      return _react2.default.createElement(_Nav2.default, _extends({
	        style: { transform: 'translateY(' + offsetY + '%)' },
	        className: 'flex dn-ns flex-column w-100 absolute z-1 bg-inherit shadow-3'
	      }, props));
	    }
	  );
	};
	
	exports.default = MobileNav;
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var paths = ['work', 'blog', 'contact'];
	
	var navLinkClass = '\n  flex-auto link\n  near-white hover-gold b\n  tc ttu tracked\n  f3 f5-ns\n  pv3 ml4-ns\n  b--dark-gray bt b--none-ns\n';
	
	var Nav = function Nav(_ref) {
	  var onNavigate = _ref.onNavigate,
	      props = _objectWithoutProperties(_ref, ['onNavigate']);
	
	  return _react2.default.createElement(
	    'nav',
	    props,
	    paths.map(function (path) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          key: path,
	          to: '/' + path,
	          onClick: onNavigate,
	          className: navLinkClass
	        },
	        path
	      );
	    })
	  );
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(216);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIuNjEgNTEyLjYxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZkYjcxNDt9LmNscy0ye2ZpbGw6IzBiMGQxNTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnphcC12MjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyNTYuMyIgY3k9IjI1Ni4zIiByPSIyNTYuMyIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI3Ni45MiwyMzQuN2g4MC41MUwxNzQuOTQsNDE3LjE5bDYwLjEzLTE0MC4zOEgxNTUuMThMMzM2LjU3LDk1LjQyWiIvPjwvc3ZnPg=="

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(386);
	
	var _Header = __webpack_require__(218);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(214);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex flex-column flex-auto min-vh-100 sans-serif near-black bg-near-white' },
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      'main',
	      { className: 'flex-auto' },
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c00863b8bc75365b0efe.js